/// <reference path="../typedefs/dash.js" />
import { apiAction, promiseApiAction } from 'actions/application'
import { createAction } from 'actions/utils'
import mutationErrorHandler from 'sagas/errorHandlers/mutationErrorHandler'
import {
  getSwitches,
  saveDashboard,
  getDashboard,
  getSearchedCustomSwitches,
  getSwitchLinkedReferenceParameter,
  getSwitchLinkedFeatures,
  getLayoutBlacklist,
  getCustomSwitchGraphic,
  saveCustomSwitchGraphicsDetails,
  updateLayoutLocation,
  createApprovedLayout,
} from 'services/dash'

export const CLEAR_DRAG_ITEM = 'CLEAR_DRAG_ITEM'
/**
 *
 */
export const clearDragItem = createAction(CLEAR_DRAG_ITEM)

export const ADD_SWITCH_TO_LOCATION = 'ADD_SWITCH_TO_LOCATION'
/**
 *
 */
export const addSwitchToLocation = createAction(ADD_SWITCH_TO_LOCATION, [
  'panelNumber',
  'location',
])

export const REQUESTING_CUSTOM_SWITCH_GRAPHIC =
  'REQUESTING_CUSTOM_SWITCH_GRAPHIC'
export const SUCCESS_CUSTOM_SWITCH_GRAPHIC = 'SUCCESS_CUSTOM_SWITCH_GRAPHIC'
export const FAILURE_CUSTOM_SWITCH_GRAPHIC = 'FAILURE_CUSTOM_SWITCH_GRAPHIC'
/**
 *
 * @param {*} param0
 * @returns
 */
export const fetchCustomSwitchGraphics = ({ capPartNumber }) =>
  apiAction({
    asyncFn: getCustomSwitchGraphic,
    args: { capPartNumber },
    requestActionType: REQUESTING_CUSTOM_SWITCH_GRAPHIC,
    successActionType: SUCCESS_CUSTOM_SWITCH_GRAPHIC,
    failureActionType: FAILURE_CUSTOM_SWITCH_GRAPHIC,
    id: capPartNumber,
  })

export const REQUESTING_DASH_CONFIG = 'REQUESTING_DASH_CONFIG'
export const SUCCESS_DASH_CONFIG = 'SUCCESS_DASH_CONFIG'
export const FAILURE_DASH_CONFIG = 'FAILURE_DASH_CONFIG'

// Action dispatched when navigating to S&G page to trigger notification display
export const LOAD_SNG_PAGE = 'LOAD_SNG_PAGE'
export const loadSngPage = () => ({ type: LOAD_SNG_PAGE })

/**
 * PBI 556076: Fetch dashboard configuration with success and failure actions.
 * @param {*} args
 * @returns
 */
export const fetchVehicleDashConfig = (args) =>
  promiseApiAction({
    asyncFn: getDashboard,
    args,
    requestActionType: REQUESTING_DASH_CONFIG,
    successActionType: SUCCESS_DASH_CONFIG,
    failureActionType: FAILURE_DASH_CONFIG,
    id: args.serialNumber,
  })

export const REQUESTING_SMART_SWITCHES = 'REQUESTING_SMART_SWITCHES'
export const SUCCESS_SMART_SWITCHES = 'SUCCESS_SMART_SWITCHES'
export const FAILURE_SMART_SWITCHES = 'FAILURE_SMART_SWITCHES'

/**
 *
 * @param {{ vehicleSubType: string, isAllium: boolean }} params params
 * @returns
 */
export const fetchVehicleSwitches = ({ vehicleSubType, isAllium }) =>
  apiAction({
    asyncFn: getSwitches,
    args: { vehicleSubType, isAllium },
    requestActionType: REQUESTING_SMART_SWITCHES,
    successActionType: SUCCESS_SMART_SWITCHES,
    failureActionType: FAILURE_SMART_SWITCHES,
    id: vehicleSubType,
  })

export const REQUESTING_LAYOUT_BLACKLIST = 'REQUESTING_LAYOUT_BLACKLIST'
export const SUCCESS_LAYOUT_BLACKLIST = 'SUCCESS_LAYOUT_BLACKLIST'
export const FAILURE_LAYOUT_BLACKLIST = 'FAILURE_LAYOUT_BLACKLIST'

/**
 *
 * @param {{ dashboardType: string, serialNumber: string, isAllium: boolean }} params params
 * @returns {*}
 */
export const fetchLayoutBlacklist = ({
  dashboardType,
  serialNumber,
  isAllium,
}) =>
  apiAction({
    asyncFn: getLayoutBlacklist,
    args: { dashboardType, serialNumber, isAllium },
    requestActionType: REQUESTING_LAYOUT_BLACKLIST,
    successActionType: SUCCESS_LAYOUT_BLACKLIST,
    failureActionType: FAILURE_LAYOUT_BLACKLIST,
    id: serialNumber,
  })

export const DASH_CONFIG_VALIDATE = 'DASH_CONFIG_VALIDATE'
/**
 *
 * @param {*} components
 * @returns
 */
export const validateVehicleDashConfig = (components) => ({
  type: DASH_CONFIG_VALIDATE,
  components,
})

export const DASH_CONFIG_SET_BLOCKED_LIST = 'DASH_CONFIG_SET_BLOCKED_LIST'
/**
 *
 */
export const setDashBlockedList = createAction(DASH_CONFIG_SET_BLOCKED_LIST, [
  'blockedList',
])

export const DASH_CONFIG_INVALID = 'DASH_CONFIG_INVALID'
/**
 *
 */
export const vehicleDashConfigInvalid = createAction(DASH_CONFIG_INVALID, [
  'invalidLocations',
])

export const SAVE_DASH = 'SAVE_DASH'
/**
 *
 */
export const saveDash = createAction(SAVE_DASH, ['notes'])

export const SAVE_DASH_CONFIG = 'SAVE_DASH_CONFIG'
export const SUCCESS_SAVE_DASH_CONFIG = 'SUCCESS_SAVE_DASH_CONFIG'
export const FAILURE_SAVE_DASH_CONFIG = 'FAILURE_SAVE_DASH_CONFIG'
/**
 * If updateFromEdex, notes are empty, and add updateFromEdex boolean props.
 * If updateFromEdex, requestBody components is truncated to to just keep/remove switches list.
 *
 * @typedef SaveDashComponentsAction
 * @property {SaveDashComponentsPostBody} requestBody
 * @property {string} serialNumber
 *
 * @param {SaveDashComponentsAction} object
 * @returns {Promise} Promise
 */
export const saveDashConfig = ({ serialNumber, requestBody }) =>
  apiAction({
    asyncFn: saveDashboard,
    args: { serialNumber, requestBody },
    requestActionType: SAVE_DASH_CONFIG,
    successActionType: SUCCESS_SAVE_DASH_CONFIG,
    failureActionType: FAILURE_SAVE_DASH_CONFIG,
    id: `${serialNumber}`,
  })

export const SWITCH_LINKED_REFERENECE_PARAMETERS_RECIEVED =
  'SWITCH_LINKED_REFERENECE_PARAMETERS_RECIEVED'
export const GET_SWITCH_LINKED_LOGIC = 'GET_SWITCH_LINKED_REFERENCE_PARAMETERS'
/**
 *
 * @param {*} param0
 * @returns
 */
export const fetchSwitchLinkedReferenceParameters = ({
  switchId,
  serialNumber,
}) =>
  apiAction({
    asyncFn: getSwitchLinkedReferenceParameter,
    args: { switchId, serialNumber },
    successActionType: SWITCH_LINKED_REFERENECE_PARAMETERS_RECIEVED,
    id: `${serialNumber}/${switchId}`,
  })

export const SWITCH_LINKED_FEATURES_RECIEVED = 'SWITCH_LINKED_FEATURES_RECIEVED'
export const GET_SWITCH_LINKED_FEATURES = 'GET_SWITCH_LINKED_FEATURES'
/**
 *
 * @param {*} param0
 * @returns
 */
export const fetchSwitchLinkedFeatures = ({ switchId, serialNumber }) =>
  apiAction({
    asyncFn: getSwitchLinkedFeatures,
    args: { switchId, serialNumber },
    successActionType: SWITCH_LINKED_FEATURES_RECIEVED,
    id: `${serialNumber}/${switchId}`,
    errorHandlers: [mutationErrorHandler],
  })

export const DISPLAY_ALL_LOCATIONS = 'DISPLAY_ALL_LOCATIONS'
export const setDisplayAllLocations = createAction(DISPLAY_ALL_LOCATIONS, [
  'displayAllLocations',
])

export const ON_DASH_DRAG = 'ON_DASH_DRAG'
export const onDashDrag = createAction(ON_DASH_DRAG, ['draggingItem'])

export const OFF_DASH_DRAG = 'OFF_DASH_DRAG'
export const offDashDrag = createAction(OFF_DASH_DRAG)

export const ON_DRAG_DROP = 'ON_DRAG_DROP'
export const onDragDrop = createAction(ON_DRAG_DROP, ['dropItem'])

export const RESET_VEHICLE_DASH = 'RESET_VEHICLE_DASH'
export const resetVehicleDash = createAction(RESET_VEHICLE_DASH)

export const REMOVE_COMPONENT = 'REMOVE_COMPONENT'
export const removeComponent = createAction(REMOVE_COMPONENT, ['location'])

export const DISPLAY_PARTS_WITHOUT_LOCATION_BANNER =
  'DISPLAY_PARTS_WITHOUT_LOCATION_BANNER'
export const displayPartsWithoutLocation = createAction(
  DISPLAY_PARTS_WITHOUT_LOCATION_BANNER
)

export const DISPLAY_ALLIUM_DATA_BANNER = 'DISPLAY_ALLIUM_DATA_BANNER'
export const displayAlliumDataBanner = createAction(DISPLAY_ALLIUM_DATA_BANNER)

export const SAVED_WITH_ALLIUM_ERRORS_BANNER = 'SAVED_WITH_ALLIUM_ERRORS_BANNER'
export const displaySavedWithAlliumErrorsBanner = createAction(
  SAVED_WITH_ALLIUM_ERRORS_BANNER
)

export const REMOVE_PARTS_WITHOUT_LOCATION_BANNER =
  'REMOVE_PARTS_WITHOUT_LOCATION_BANNER'
export const removePartsWithoutLocationBanner = createAction(
  REMOVE_PARTS_WITHOUT_LOCATION_BANNER
)

export const REMOVE_SNG_PENDING_NOTIFICATION = 'REMOVE_SNG_PENDING_NOTIFICATION'
export const removeSngPendingNotification = createAction(
  REMOVE_SNG_PENDING_NOTIFICATION
)

export const REQUESTING_SEARCHED_CUSTOM_SWITCHES =
  'REQUESTING_SEARCHED_CUSTOM_SWITCHES'
export const SUCCESS_SEARCHED_CUSTOM_SWITCHES =
  'SUCCESS_SEARCHED_CUSTOM_SWITCHES'
export const FAILURE_SEARCHED_CUSTOM_SWITCHES =
  'FAILURE_SEARCHED_CUSTOM_SWITCHES'
/**
 *
 * @param {*} searchedString
 * @returns
 */
export const fetchSearchedCustomSwitches = ({
  searchedString,
  panelNumber,
  resolve = () => {},
  reject = () => {},
  errorHandlers,
}) =>
  apiAction({
    asyncFn: getSearchedCustomSwitches,
    args: { searchedString, panelNumber },
    requestActionType: REQUESTING_SEARCHED_CUSTOM_SWITCHES,
    successActionType: SUCCESS_SEARCHED_CUSTOM_SWITCHES,
    failureActionType: FAILURE_SEARCHED_CUSTOM_SWITCHES,
    resolve,
    reject,
    // Include panelNumber so that two searches for the same string on different
    // panels get distinct de-dup signals. Without panelNumber, the second search
    // resolves with undefined and the callback crashes on res.data.length.
    id: `${searchedString}-${panelNumber}`,
    errorHandlers,
  })

export const ADD_CUSTOM_GRAPHICS_TO_SWITCH = 'ADD_CUSTOM_GRAPHICS_TO_SWITCH'

/**
 * To add a new custom switch cap to the store.
 * @param {string} partNumber - The cap part number, typically starts with MQT
 * @param {string} description - The cap description.
 * @param {string} partNumber - The component panelNumber, used as the key in the store, since caps graphics are pull from panelNumber.
 *
 */
export const addCustomGraphicsToSwitch = createAction(
  ADD_CUSTOM_GRAPHICS_TO_SWITCH,
  ['partNumber', 'description', 'panelNumber']
)

export const SET_SWTICH_DETAILS_CHANGED = 'SET_SWTICH_DETAILS_CHANGED'
/**
 *
 */
export const setSwitchDetailsChanged = createAction(SET_SWTICH_DETAILS_CHANGED)

export const RESET_SWTICH_DETAILS_CHANGED = 'RESET_SWTICH_DETAILS_CHANGED'
/**
 *
 */
export const resetSwitchDetailsChanged = createAction(
  RESET_SWTICH_DETAILS_CHANGED
)

export const SAVE_CUSTOM_SWITCH_GRAPHICS = 'SAVE_CUSTOM_SWITCH_GRAPHICS'
/**
 *
 */
export const saveCustomSwitchGraphics = createAction(
  SAVE_CUSTOM_SWITCH_GRAPHICS,
  ['notes']
)

export const SAVE_CUSTOM_SWITCH_CONFIG = 'SAVE_CUSTOM_SWITCH_CONFIG'
export const SUCCESS_SAVE_CUSTOM_SWITCH_CONFIG =
  'SUCCESS_SAVE_CUSTOM_SWITCH_CONFIG'
export const FAILURE_SAVE_CUSTOM_SWITCH_CONFIG =
  'FAILURE_SAVE_CUSTOM_SWITCH_CONFIG'
/**
 *
 * @param {*} param0
 * @returns
 */
export const saveCustomSwitchConfig = ({ serialNumber, requestBody }) =>
  apiAction({
    asyncFn: saveCustomSwitchGraphicsDetails,
    args: { serialNumber, requestBody },
    requestActionType: SAVE_DASH_CONFIG,
    successActionType: SUCCESS_SAVE_DASH_CONFIG,
    failureActionType: FAILURE_SAVE_DASH_CONFIG,
    id: `${serialNumber}`,
  })

export const SET_UNASSIGNED_LOCATION_DATA = 'SET_UNASSIGNED_LOCATION_DATA'
export const setUnassignedLocationData = createAction(
  SET_UNASSIGNED_LOCATION_DATA,
  ['location', 'locationDetail', 'locationType']
)

export const RESET_SELECTED_LOCATION_TYPE = 'RESET_SELECTED_LOCATION_TYPE'
export const resetSelectedLocationType = createAction(
  RESET_SELECTED_LOCATION_TYPE,
  ['location']
)

export const ADD_MSF = 'ADD_MSF'
export const setAddMsfFlag = createAction(ADD_MSF, ['addMsf', 'id'])

export const ADD_MSF_TO_LOCATION = 'ADD_MSF_TO_LOCATION'
export const addMsfToLocation = createAction(ADD_MSF_TO_LOCATION, ['location'])

export const REMOVE_MSF = 'REMOVE_MSF'
export const setRemoveMsfFlag = createAction(REMOVE_MSF, ['removeMsf', 'id'])

export const REMOVE_MSF_FROM_LOCATION = 'REMOVE_MSF_FROM_LOCATION'
export const removeMsfFromLocation = createAction(REMOVE_MSF_FROM_LOCATION, [
  'location',
])

export const SET_MSF_MODAL_OPEN = 'SET_MSF_MODAL_OPEN'
export const setMsfModalOpen = createAction(SET_MSF_MODAL_OPEN, [
  'isOpen',
  'panelId',
  'enableAddMsf',
  'disableAddMsfReason',
])

export const ADD_COMPONENT_TO_STAGING = 'ADD_COMPONENT_TO_STAGING'
export const addComponentToStaging = createAction(ADD_COMPONENT_TO_STAGING, [
  'location',
])

export const SAVE_LAYOUT_LOCATION = 'SAVE_LAYOUT_LOCATION'
export const SUCCESS_SAVE_LAYOUT_LOCATION = 'SUCCESS_SAVE_LAYOUT_LOCATION'
export const FAILURE_SAVE_LAYOUT_LOCATION = 'FAILURE_SAVE_LAYOUT_LOCATION'
/**
 * Action to POST layout location data to the server.
 *
 * @typedef {Object} SaveDashLayoutLocationAction
 * @property {string} id
 * @property {SaveDashLayoutLocationPostBody} body
 *
 * @param {SaveDashLayoutLocationAction} object
 * @returns {Promise} Promise
 */
export const saveLayoutLocation = ({ id, body }) =>
  apiAction({
    asyncFn: updateLayoutLocation,
    args: { id, body },
    requestActionType: SAVE_LAYOUT_LOCATION,
    successActionType: SUCCESS_SAVE_LAYOUT_LOCATION,
    failureActionType: FAILURE_SAVE_LAYOUT_LOCATION,
    id: `${SAVE_LAYOUT_LOCATION}-${id}`,
  })

export const UPDATE_LOCATION = 'UPDATE_LOCATION'
/**
 * Action to update a dash layout location object.
 *
 * @param {string} type
 * @param {DashLayoutLocation} location
 */
export const updateLocation = createAction(UPDATE_LOCATION, ['location'])

export const RESET_LOCATION = 'RESET_LOCATION'
/**
 * Action to reset a dash layout location data.
 *
 * @param {string} type
 * @param {string} location
 */
export const resetLocation = createAction(RESET_LOCATION, ['location'])

export const SET_LAYOUT_LOCATION_TO_UPDATE = 'SET_LAYOUT_LOCATION_TO_UPDATE'
/**
 * Action to set a place to hold a temp verion of the layout location data being edited.
 *
 * @type {function}
 * @param {DashLayoutLocation} location
 * @return {object}
 */
export const setLayoutLocationToUpdate = createAction(
  SET_LAYOUT_LOCATION_TO_UPDATE,
  ['location']
)

export const SET_HAS_APPROVED_LAYOUT = 'SET_HAS_APPROVED_LAYOUT'
/**
 * Action to set the has approved layout flag which is needed for state management in UI.
 *
 * @type {function}
 * @param {bool} hasApproved
 * @return {object}
 */
export const setHasApprovedLayout = createAction(SET_HAS_APPROVED_LAYOUT, [
  'hasApproved',
])

export const REQUEST_SAVE_APPROVED_LAYOUT = 'REQUEST_SAVE_APPROVED_LAYOUT'
export const SUCCESS_SAVE_APPROVED_LAYOUT = 'SUCCESS_SAVE_APPROVED_LAYOUT'
export const FAILURE_SAVE_APPROVED_LAYOUT = 'FAILURE_SAVE_APPROVED_LAYOUT'
/**
 * Action to POST layout location data to the server.
 *
 * @typedef {Object} SaveApprovedLayout
 * @property {string} serialNumber
 * @property {{ notes: string }} body
 *
 * @param {SaveApprovedLayout} object
 * @returns {Promise} Promise
 */
export const saveApprovedLayout = ({ serialNumber, body }) =>
  apiAction({
    asyncFn: createApprovedLayout,
    args: { serialNumber, body },
    requestActionType: REQUEST_SAVE_APPROVED_LAYOUT,
    successActionType: SUCCESS_SAVE_APPROVED_LAYOUT,
    failureActionType: FAILURE_SAVE_APPROVED_LAYOUT,
    id: `${serialNumber}`,
  })
